export const getRateLimitMessage = (error) => {
  const retryAfter = error.response?.headers?.["retry-after"];
  const retryAfterSeconds = Number(retryAfter);

  if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0) {
    const minutes = Math.ceil(retryAfterSeconds / 60);
    return minutes > 1
      ? `Se hicieron demasiados intentos. Espera ${minutes} minutos y volve a probar.`
      : "Se hicieron demasiados intentos. Espera un minuto y volve a probar.";
  }

  return "Se hicieron demasiados intentos desde esta conexion. Espera unos minutos y volve a probar.";
};
